'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './text-list.routes';

export class TextListComponent {

  constructor(Auth, dialogs, $uibModal, MailsService, $stateParams, $location, Upload, TextMessagesService) {
    'ngInject';
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.TextMessagesService = TextMessagesService;
    this.Upload = Upload;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;

    this.type = $stateParams.type;

    this.noData = false;
    this.count = {};

    this.getData();

  }

  getData() {
    this.TextMessagesService.getByType({type: this.type}, (data) => {
      this.textList = data;

      if (this.textList.length == 0) {
        this.noData = true;
      }
    }, err => {
      console.log("Could not retrieve mail lists from server.")
    });

    this.count["draft"] = 0;
    this.count["sent"] = 0;

    this.TextMessagesService.query(data => {
      data.forEach(text => {
        if (text.type) {
          if (!this.count[text.type]) {
            this.count[text.type] = 0;
          }
          this.count[text.type]++;
        }
      })
    });
  }

  openRecipientsModal(text) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'datatableViewer',
      resolve: {
        config: function () {
          return {
            data: text.recipients.map(mail => [mail]) || [],
            settings: {
              "columns": [
                "Cell Numbers"
              ]
            },
            name: "Text Message Recipient List"
          }
        }
      },
      size: 'lg'
    });
  }

  send(textMessage) {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'textMessageFilterSendComponent',
      resolve: {
        config: function() {
          return {
            textMessage: textMessage
          }
        }
      },
      size: 'lg',
      windowClass: 'xl-modal'
    });

    modalInstance.result.then(
      function (result) {

        that.getData();

        that.dialogs.notify("Text message has been sent", "The text message has been sent successfully");

      },
      function () {  }
    );

  }

  delete(text) {
    var that = this;

    var listText = "<br/><br/><b>" + text.body + "</b>";

    var dlg = this.dialogs.confirm("Delete Text Message?", "Do you really want to delete this text message?" + listText);
    dlg.result.then(() => {
      // OK delete it
      that.TextMessagesService.delete({id: text._id},
        () => {
          that.textList = that.textList.filter(function( obj ) {
            return obj._id !== text._id;
          });

          that.count[that.type]--;
        },
        err => {
          alert("Could not delete text message");
        });
    }, () => {
      // Cancel
    });
  }

  addTextMessage() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'textMessageEdit',
      resolve: {
        config: function() {
          return {
            data: ''
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (message) {

        const textMessage = {
          body: message,
          type: 'draft',
          meta: {
            creationUser: that.Auth.getCurrentUserSync()._id
          }
        }

        that.TextMessagesService.save(textMessage, newTextMessage => {
          console.log(newTextMessage);
          that.count['draft'] = that.count['draft'] ? that.count['draft'] + 1 : 1;
          that.textList.push(newTextMessage);
          console.log(that.textList);
        }, err => {
          console.log(err);
          alert('There was an error trying to create the text message');
        })

      },
      function () { /* cancel */ }
    );

  }


  editTextMessage(text) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'textMessageEdit',
      resolve: {
        config: function() {
          return {
            data: text.body
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (message) {

        text.body = message;

        that.TextMessagesService.update({id: text._id}, text, _ => {
          that.getData();
        }, err => {
          console.log(err);
          alert('There was an error trying to update the text message');
        })

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.textList', [uiRouter])
  .config(routes)
  .component('textList', {
    template: require('./text-list.html'),
    controller: TextListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/text/list/text-list.component.js